import React from "react";
export function Checkbox({ checked = false, onChange, label, disabled = false, style = {} }) {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: 10, minHeight: "var(--h-field)", cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.5 : 1, ...style }}>
      <input type="checkbox" className="dc-chk" checked={checked} disabled={disabled}
        onChange={onChange ? (e) => onChange(e.target.checked) : undefined} />
      {label ? <span style={{ fontSize: "var(--type-label-size)", color: "var(--fg-4)" }}>{label}</span> : null}
    </label>
  );
}
